import { api } from '../services/api';

/** * Create Suggestion / Issue */
export const sendSuggestionAPI = (form, config = {}) => {
  const headers = { ...(config.headers) };

  if (typeof FormData !== 'undefined' && form instanceof FormData) {
    delete headers['Content-Type'];
    delete headers['content-type'];
  }

  return api.post(
    'api/Application/SaveFeedbackDetails',
    form,
    {
      ...config,
      headers,
    }
  );
};

/** * Get Suggestions / Issues list */
export const getFeedbackByUserIdAPI = (userId, params = {}, config = {}) => {
  return api.get(
    `api/Application/GetFeedbackDetailsByUserId/${userId}`,
    {
      ...config,
      params,
    }
  );
};

/** * Download attachment by fileId */

export const downloadFileByIdAPI = (fileId) => {
  return api.get(
    `api/Application/DownloadFileById/${fileId}`,
    {
      responseType: 'blob', //  IMPORTANT
    }
  );
};
